<template>
    <el-dialog
        :visible="visible"
        :close-on-click-modal="false"
        class="ah-upsert-dialog outsourcing-person-upsert-bankaccount-dialog"
        append-to-body
        top="5vh"
        :before-close="onClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">
            <div>{{ form.sno ? "編輯" : "新增" }}銀行帳戶</div>
        </template>
        <div>
            <el-form :model="form" ref="form" label-position="right" label-width="150px" size="small">
                <el-form-item prop="accountType" label="帳戶類型">
                    <el-radio-group v-model="form.accountType">
                        <el-radio :label="1">本國帳戶</el-radio>
                        <el-radio :label="2">外國帳戶</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="bnK_TPC" label="戶名" :rules="rules.bnK_TPC">
                    <el-input v-model="form.bnK_TPC" style="width: 100%" :maxlength="200" :show-word-limit="true"></el-input>
                </el-form-item>
                <el-form-item v-if="form.accountType === 1" prop="bnK_BOO" label="銀行" :rules="rules.bnK_BOO">
                    <ah-el-select-bank v-model="form.bnK_BOO" :branch="form.bnK_DOO" @branchInput="form.bnK_DOO = $event" style="max-width: 550px"></ah-el-select-bank>
                </el-form-item>
                <el-form-item v-if="form.accountType === 2" prop="abroadBankName" label="銀行名稱（英文）">
                    <el-input v-model="form.abroadBankName" :maxlength="40" :show-word-limit="true"></el-input>
                </el-form-item>
                <el-form-item v-if="form.accountType === 2" prop="swiftCode" label="SWIFT Code">
                    <el-input v-model="form.swiftCode" style="max-width: 500px" :maxlength="40" :show-word-limit="true"></el-input>
                </el-form-item>
                <el-form-item prop="bnK_ACC" label="收款帳號" :rules="rules.bnK_ACC">
                    <div style="max-width: 400px">
                        <ah-el-input-bank-acc v-model="form.bnK_ACC" :bankBoo="form.bnK_BOO"></ah-el-input-bank-acc>
                    </div>
                </el-form-item>
                <el-form-item prop="note">
                    <template slot="label">備註<ah-tip>顯示於請款單的委外廠商/個人資料。</ah-tip></template>
                    <el-input v-model="form.note" style="max-width: 350px" :maxlength="50" :show-word-limit="true"></el-input>
                </el-form-item>
                <el-form-item prop="passbookDoc" label="存摺封面">
                    <div class="document-section">
                        <div style="max-width: 300px;">
                            <div v-if="form.passbookDoc" class="document-block">
                                <el-image :src="form.passbookDoc" :previewSrcList="[form.passbookDoc]" style="width: 100%; height: 100%" fit="contain"></el-image>
                            </div>
                            <ahUploader
                                :value="form.passbookDoc"
                                ref="ahUploader"
                                head-shot
                                accept="image/png, image/jpeg"
                                :watermark="`僅供 ${companyName} 請款使用`"
                                @change="($event) => onChangeAttachment($event)"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-if="form.bnK_TPC && form.bnK_TPC !== fnam" label="匯款同意書">
                    <div>
                        <el-alert type="warning" style="display: inline-block; width: auto; padding: 0 10px" :closable="false">
                            收款戶名與廠商名稱不符，請付上匯款同意書與指定收款人帳戶存摺照片
                        </el-alert>
                    </div>
                    <el-upload
                        class="ah-img-upload-rect"
                        action="https://api.sokuji.tw/api/v1/Tool/UploadImg"
                        :data="{ uploadType: 1 }"
                        :headers="headers"
                        :show-file-list="false"
                        :on-success="
                            (res) => {
                                form.filE_AGREE = res.imgUrl;
                            }
                        "
                        :before-upload="beforeAvatarUpload"
                    >
                        <div v-if="form.filE_AGREE" class="upload-display change">
                            <img :src="form.filE_AGREE" alt="" class="uploaded-img" />
                            <div class="hint">更換檔案</div>
                        </div>
                        <div v-else class="upload-display">
                            <div class="text">上傳檔案</div>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 30px; display: flex; justify-content: end">
            <el-button type="normal" @click="onClose" icon="el-icon-close">取消{{ form.sno ? "編輯" : "新增" }}</el-button>
            <el-button type="primary" class="primary-action" @click="onSubmit" icon="el-icon-check">{{ form.sno ? "儲存" : "新增" }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import ahElSelectBank from '@/components/ui/ahElSelectBank.vue';
import ahElInputBankAcc from '@/components/ui/ahElInputBankAcc.vue';
import { checkFileSize, checkFilePictureType } from '@/utils/fileValidator';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';

export default {
    name: 'outsourcing-person-bankaccount-upsert-dialog',
    components: { ahElSelectBank, ahElInputBankAcc, ahUploader },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => {},
        },
        fnam: {
            type: String,
            default: null,
        },
    },
    computed: {
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
    },
    data() {
        return {
            // 資料表單
            form: {
                sno: null,
                accountType: 1,
                bnK_BOO: null,
                bnK_DOO: null,
                bnK_TPC: null,
                bnK_ACC: null,
                swiftCode: null,
                abroadBankName: null,
                passbookDoc: null,
                filE_AGREE: null,
                note: null,
            },
            // 表單驗證
            rules: {
                bnK_TPC: [{ required: true, message: '請輸入戶名', trigger: 'blur' }],
                bnK_ACC: [{ required: true, message: '請輸入帳號', trigger: 'blur' }],
                bnK_BOO: [{ required: true, message: '請輸入銀行', trigger: 'blur' }],
                // bnK_DOO: [{ required: true, message: '請輸入分行', trigger: 'blur' }],
                abroadBankName: [{ required: true, message: '請輸入銀行名稱', trigger: 'blur' }],
                swiftCode: [{ required: true, message: '請輸入SwiftCode', trigger: 'blur' }],
            },

            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        };
    },
    methods: {
        // 開啟視窗
        onOpen() {
            console.log('opend');

            if (this.data) {
                this.form.sno = this.data.sno;
                this.form.accountType = this.data.accountType;
                this.form.bnK_BOO = this.data.bnK_BOO;
                this.form.bnK_DOO = this.data.bnK_DOO;
                this.form.bnK_TPC = this.data.bnK_TPC;
                this.form.bnK_ACC = this.data.bnK_ACC;
                this.form.swiftCode = this.data.swiftCode;
                this.form.passbookDoc = this.data.passbookDoc;
                this.form.note = this.data.note;
                this.form.filE_AGREE = this.data.filE_AGREE;
            }
        },

        // 關閉視窗
        onClose() {
            this.$emit('close');
            this.form = {
                sno: null,
                accountType: 1,
                bnK_BOO: null,
                bnK_DOO: null,
                bnK_TPC: null,
                bnK_ACC: null,
                swiftCode: null,
                passbookDoc: null,
                filE_AGREE: null,
                note: null,
            };
        },

        // 送出
        onSubmit() {
            try {
                this.$refs.form.validate(async (valid) => {
                    if (!valid) return;
                    this.$emit('submit', this.form);
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        beforeAvatarUpload(file) {
            const fileSizeErrMsg = checkFileSize(file.size);
            if (fileSizeErrMsg) {
                this.$message({
                    showClose: true,
                    message: fileSizeErrMsg,
                    type: 'error',
                });
                return false;
            }

            const fileTypeErrMsg = checkFilePictureType(file.type);
            if (fileTypeErrMsg) {
                this.$message({
                    showClose: true,
                    message: fileTypeErrMsg,
                    type: 'error',
                });
                return false;
            }
            return true;
        },

        onChangeAttachment(val) {
            this.form.passbookDoc = val.filE_ATT;
        },
    },
};
</script>
<style lang="scss">
.outsourcing-person-upsert-bankaccount-dialog {
    .el-dialog {
        max-width: 720px;
    }
}
</style>
